import { render, staticRenderFns } from "./ProductListItemChild.vue?vue&type=template&id=00fd3fda&scoped=true&"
import script from "./ProductListItemChild.vue?vue&type=script&lang=js&"
export * from "./ProductListItemChild.vue?vue&type=script&lang=js&"
import style0 from "./ProductListItemChild.vue?vue&type=style&index=0&id=00fd3fda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fd3fda",
  null
  
)

export default component.exports